import { render, staticRenderFns } from "./GenericBTable.vue?vue&type=template&id=a26c3df8&scoped=true"
import script from "./GenericBTable.vue?vue&type=script&lang=js"
export * from "./GenericBTable.vue?vue&type=script&lang=js"
import style0 from "./GenericBTable.vue?vue&type=style&index=0&id=a26c3df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26c3df8",
  null
  
)

export default component.exports